import { BasePageQuotation } from 'design-system';
import { ErrorLayout } from '../../../components';

export const errorMessage = 'No se encontraron datos para la cotización';

const ErrorSubScreen = (): JSX.Element => (
  <BasePageQuotation leftActions="" rightActions="" backgroundColor="white">
    <ErrorLayout titleMessage={errorMessage} />
  </BasePageQuotation>
);

export default ErrorSubScreen;
